import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthngkService } from 'src/app/core/services/authngk.service';
import { Router } from '@angular/router';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    constructor(
        private router: Router,
        private authngkService: AuthngkService
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(error => {
            if (error.status === 401) {
                // auto logout if 401 response returned from api
                this.authngkService.logOut();
                this.router.navigate(['/account/login']);
                /* location.reload(); */
            }

            //const error = err.error.message || err.statusText;
            return throwError(error);
        }));
    }
}
